import ClientPortal from '../../../plugins/axios'

export default {
    // User Login
    userInfo(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/userInfo`,
            userCredential
        )
    },
    userDependent(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/userDependent`,
            userCredential
        )
    },

    userUtil(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/userUtil`,
            userCredential
        )
    },

    // Forgot Password
    forgotPassUserInfo(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/forgotPassUserInfo`,
            userCredential
        )
    },

    forgotPassRecoveryLink(userCredential) {
    // console.log("Executed 4")
        const api_res = ClientPortal.post(
            `${process.env.VUE_APP_API}/login/forgotPassRecoveryLink`,
            userCredential
        )
        // console.log(api_res);
        return api_res
    },
  
    verifyForgotPassRecoveryLink(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/verifyForgotPassRecoveryLink`,
            userCredential
        )
    },
    resetPassword(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/resetPassword`,
            userCredential
        )
    },

    //Manage Account API's
    userAccountCred(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/accountCred`,
            userCredential
        )
    },
    // Update Email
    manageAccountEmail(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/updateEmail`,
            userCredential
        )
    },
    // Update CP #
    manageAccountCPno(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/updateCpno`,
            userCredential
        )
    },
    // Update Pass
    manageAccountPass(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/updatePass`,
            userCredential
        )
    },

    manageAccountAddress(userCredential) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/updateAddress`,
            userCredential
        )
    }
}
